import { useCallback } from 'react';
import { useParams, useRouter } from 'next/navigation';
import { getLocalizationInfo } from 'project.config';
import usePath from './usePath';

const useCountry = () => {
  const router = useRouter();

  const { path } = usePath();
  const { locale } = useParams();
  const { country, language } = getLocalizationInfo(locale);
  const setCountry = useCallback(
    (newCountry: typeof country) => {
      router.push(`/${newCountry.countryCode.toLowerCase()}-${language.slice(0, 2).toLowerCase()}${path}`);
    },
    [language, path, router],
  );
  return [country, setCountry] as const;
};

export default useCountry;
